module.exports = __webpack_public_path__ + "static/media/432744598_773193031084654_2082836041905563819_n.675b0e83.jpg";